import { lighten } from '@material-ui/core/styles/colorManipulator';
export default (theme)=>({
    root: {
        paddingRight: theme.spacing.unit,
      },
      icon:{
          color:'white',
      },
      highlight:
        theme.palette.type === 'light'
          ? {
              color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
          : {
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.secondary.dark,
            },
      spacer: {
        flex: '1 1 100%',
      },
      actions: {
        '&>div':{
          position:'relative',
          top: 4,
        },
        margin:'10px 0px 0px 0px',
        '@media (max-width: 599px)': {
          margin:'-20px 0px 0px 0px',
          paddingBottom:10,
        },
        textAlign: 'right',
        color: theme.palette.text.secondary,
      },
      pagination: {
        margin:'-7px 0px 0px 0px',
        textAlign: 'center',
        '& button':{
          width:'10px',
        }
      }
})


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/tableActions.jsx